// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/radio-speech-and-operating-practice.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/radio-speech-and-operating-practice/radio-speech-and-operating-practice.js';
import g1 from '../lessons/air-law/radio-speech-and-operating-practice/radiocommunication-language.js';

mount([g0, g1]);
